import './style.scss';
import {autoplaySwiper} from '../../scripts/autoplay-swiper';

export function brands_logo_block() {
    const blocks = document.querySelectorAll('.brands_logo_block');
    if (!blocks.length) return;

    blocks.forEach((block) => {
        autoplaySwiper(block, {
            slidesPerView: 'auto',
            spaceBetween: 30,
            speed: 40000,
            breakpoints: {
                600: {slidesPerView: 'auto', spaceBetween: 50},
                1024: {slidesPerView: 'auto', spaceBetween: 85},
                1280: {slidesPerView: 'auto', spaceBetween: 100},
                1440: {slidesPerView: 'auto', spaceBetween: 134},
            },
        });
    });
}